import { Container } from "reactstrap"
import styles from "./PaymentDetail.module.scss"
import FilterInTable from "../../../../Manage/FilterInTable"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import InfoBadge from "../../../../../components/common/SellerCommonComponents/InfoBadge/InfoBadge"

const PaymentDetail = () => {

  const data = [
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
    {
      date: "08/06/2024",
      type: "Sale",
      transactionId: "#12345",
      orderId: "#12345",
      details: "Blue colored headphones",
      productCharges: "$50",
      promotionalCharges: "$0",
      maelanoFee: "-$4.00",
      other: "-$1.00",
      total: "$45",
      statement: "08/06/2024",
    },
  ]

  const columns = [
    { name: "Date", selector: (row) => row.date },
    { name: "Transaction type", selector: (row) => row.type },
    { name: "Transaction #", selector: (row) => row.transactionId },
    { name: "Order #", selector: (row) => row.orderId },
    { name: "Details", selector: (row) => row.details, wrap: true },
    { name: "Product Charges", selector: (row) => row.productCharges },
    { name: "Promotional charges", selector: (row) => row.promotionalCharges },
    { name: "Maelano fee", selector: (row) => row.maelanoFee },
    { name: "Other", selector: (row) => row.other },
    { name: "Total", selector: (row) => row.total },
    { name: "Statement", selector: (row) => row.statement },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh" }}>
      <Container fluid>
        <h4 className="fw-semibold py-3">Transaction History</h4>

        <div className="bg-white p-3 d-flex flex-column gap-3">
          <div className="d-flex">
            <InfoBadge>Total: 500</InfoBadge>
          </div>
          <FilterInTable componentName="Pricing and Finance Payment Info" />
          <DatatableComponent data={data} columns={columns} type="gray" pagination />
        </div>
      </Container>
    </div>
  )
}

export default PaymentDetail
